import { formatNumber } from 'devextreme/localization';
import { useContext, } from 'react';
import { Field, Panel } from '../../../../layouts';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function RetailOrderInformationPanel() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			<Panel
				header={'Order Information'}
				className="field-label-35"
			>
				<Field label={'Retail Order #'} >{order.details.retailOrder.roNumber}</Field>
				<Field label={'Total Retail Price'} >{formatNumber(order.details.retailOrder.retailTotal, { type: 'currency', precision: 2 })}</Field>
				<Field label={'Product Line'} >{order.details.retailOrder.productLine}</Field>
				<Field label={'Color'}>{order.details.retailOrder.colors.join(", ")}</Field>
			</Panel>
		</>
	);
}
